<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card v-bind:title="'Edit Tipe Remunerasi'">
          <template
            v-slot:body
            v-if="dataLoaded"
          >
            <Form
              :form="form"
              :route="'remuneration-types/' + form.id"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/masters/remuneration-types/Form.vue'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        name: "",
        description: "",
        period:"",
        paid_date:"",
        is_tax:false,
      },
      // Other
      dataLoaded: false
    }
  },

  methods: {

    async get() {
      this.form = await module.get('remuneration-types/' + this.$route.params.id)

      if (this.form == null) {
        // Redirect To List
        this.$router.push('/masters/remuneration-types/list')
      } else {
        this.form['_method'] = 'put'
        this.dataLoaded = true
      }
    }

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
     { title: "Tipe Remunerasi", route: "" },
      { title: "Daftar Tipe Remunerasi", route: "/masters/remuneration-types/list" },
      { title: "Ubah" },
    ])
    // Get Data
    this.get()
  },

}

</script>